import { render, staticRenderFns } from "./BusinessUsersInviteAcceptView.vue?vue&type=template&id=9cce0526&scoped=true"
import script from "./BusinessUsersInviteAcceptView.vue?vue&type=script&lang=js"
export * from "./BusinessUsersInviteAcceptView.vue?vue&type=script&lang=js"
import style0 from "./BusinessUsersInviteAcceptView.vue?vue&type=style&index=0&id=9cce0526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cce0526",
  null
  
)

export default component.exports